import { Component, inject, Input } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../services/toast.service';

@Component({
	selector: 'app-link-modal',
	template: `
		<div class="modal-header">
			<h4 class="modal-title">{{ title }}</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
		</div>
		<div class="modal-body">
				<p>
					@if (body) {
						{{ body }}
					}
				</p>
				<a [href]="link" target="_blank">{{ link }}</a>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="copyLink(link)" i18n>Copia Link</button>
		</div>
	`
})
export class LinkModal {
	private readonly fb = inject(NonNullableFormBuilder);
	private readonly toastSrv = inject(ToastService);
	
	activeModal = inject(NgbActiveModal);

	motivationForm: FormGroup = this.fb.group({
		motivation: ['', [Validators.required, Validators.minLength(7)]]
	});

	@Input() title: string = '';
	@Input() body!: string;
	@Input() link: string = '';

	copyLink(link: string) {
		navigator.clipboard.writeText(link)
			.then(() => this.toastSrv.show({ type: 'success', message: 'Link copiato negli appunti!' }));
	}
}